import * as React from 'react';
import { createUseStyles } from 'react-jss';
import BackFields from '../fields/BackFields';
import { useTheme } from '../../Theme';
const useStyles = createUseStyles({
  root: {
    backgroundColor: '#f3f3f3',
    filter: 'drop-shadow(5px 11px 15px rgba(0, 0, 0, 0.2))',
    padding: ({
      theme
    }) => 14 * theme.scale,
    width: ({
      theme
    }) => 320 * theme.scale,
    height: ({
      theme
    }) => 450 * theme.scale
  },
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
    height: ({
      theme
    }) => theme.scale * 80,
    justifyContent: 'center',
    width: '100%'
  }
});
export default function DesignerContent() {
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }), /*#__PURE__*/React.createElement(BackFields, null));
}
//# sourceMappingURL=DesignerContent.js.map